import { useEffect } from "react";
import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/analytics";

interface AnalyticsProviderProps {
  children: ReactNode;
}

const pageNameMap: Record<string, string> = {
  "dashboards": "Dashboards",
  "entrega-servicio": "Entrega de Servicio",
  "reportes": "Reports",
  "flotilla": "Fleet",
  "admin": "Admin",
  "configuracion": "Settings",
  "alertas": "Alerts",
  "geocercas": "Geofences",
  "conductores": "Drivers",
  "vehiculos": "Vehicles",
  "dispositivos": "Devices",
  "usuarios": "Users",
  "splash": "Splash",
  "login": "Login",
};

function getPageName(pathname: string): string {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return "Home";
  
  const lastSegment = segments[segments.length - 1];
  return pageNameMap[lastSegment] || lastSegment
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

/**
 * Emite una vista de pagina por cada cambio de ruta, con el nombre legible del
 * mapa de arriba, hacia Firebase Analytics y PostHog.
 *
 * La identificacion del usuario NO vive aqui: esta en analytics/identity.ts,
 * suscrito al store. Antes estaba en este componente y leia `user.role`, campo
 * que el usuario del store no tiene (es `role_id`), por lo que `user_role`
 * siempre viajaba como undefined.
 */
export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  const location = useLocation();

  useEffect(() => {
    const pageName = getPageName(location.pathname);
    trackPageView(pageName, window.location.href);
  }, [location.pathname]);

  return <>{children}</>;
}

export default AnalyticsProvider;
